import moment from 'moment';
import memoize from 'lodash/memoize';

import { ActivitySource } from '../../../types/Activity';

export const dateFormatter = memoize(
  (date: string | Date | undefined, tz: string) => {
    return `${moment(date).tz(tz).format('dddd MMMM DD, YYYY')}`;
  }
);

export const eventDateFormatter = memoize(
  (date: string | Date | undefined, tz: string) => {
    return moment(date).tz(tz).toISOString();
  }
);

export const timeFormatter = memoize(
  (date: string | Date | undefined, tz: string) => {
    return `${moment(date).tz(tz).format('LT')}`;
  }
);

export const getAvailableText = (
  capacity: number,
  isPerPerson: boolean
): string => {
  let availableText: string;
  if (capacity > 0) {
    if (!isPerPerson) {
      availableText = `Available`;
    } else availableText = `-- ${capacity} tickets available`;
  } else {
    availableText = 'Sold Out';
  }
  return availableText;
};

export const isFareharborSource = (
  source: ActivitySource | undefined = undefined
) => {
  if (!source) {
    return true;
  }
  return source === ActivitySource.fareharbor;
};

export const getIsNotIntegrationEnabled = (
  source: ActivitySource | undefined = undefined
) => {
  if (!source) {
    return false;
  }
  return ![
    ActivitySource.bach,
    ActivitySource.bach2,
    ActivitySource.externalUrl,
  ].includes(source);
};

export function hasNoBookingPlatformIntegration(
  source: ActivitySource | undefined = undefined
) {
  if (!source) {
    return true;
  }
  return [
    ActivitySource.bach,
    ActivitySource.bach2,
    ActivitySource.fareharbor,
  ].includes(source);
}

export const isAddonsSupported = (
  source: ActivitySource | undefined = undefined
) =>
  [
    ActivitySource.bach,
    ActivitySource.bach2,
    ActivitySource.externalUrl,
    ActivitySource.singenuity,
  ].includes(source || ActivitySource.bach);

export const isRedeamOrPeek = (
  source: ActivitySource | undefined = undefined
) => {
  if (!source) {
    return false;
  }
  return [
    ActivitySource.octo,
    ActivitySource.peek,
    ActivitySource.redeam,
  ].includes(source);
};

export const isRefundRequestSupported = (
  source: ActivitySource | undefined = undefined
) => {
  if (!source) {
    return false;
  }
  return [
    ActivitySource.octo,
    ActivitySource.peek,
    ActivitySource.redeam,
    ActivitySource.bach2,
    ActivitySource.singenuity,
  ].includes(source);
};
